import { publish } from '@wh/message-bus';
import {
  POPOVER_DISPLAYED,
  POPOVER_ACCEPTED,
  POPOVER_INTERACTION,
  POPOVER_DISMISSED,
  POPOVER_ERROR,
  POPOVER_TYPE_CAMPAIGN,
} from './tracking-events.constants';
import { Campaign } from '@central-products/welcome-messages-ui';

export const trackDisplayed = (campaign: Partial<Campaign>): boolean => {
  return publish(POPOVER_DISPLAYED, {
    popOverDisplayed: POPOVER_TYPE_CAMPAIGN,
    campaignId: campaign.campaign,
    campaignVersion: campaign.version,
  });
};

export const trackAccepted = (campaign: Campaign, ctaUrl: string): boolean => {
  return publish(POPOVER_ACCEPTED, {
    buttonName: campaign.ctaSection.CTAText,
    link: ctaUrl,
    campaignId: campaign.campaign,
    campaignVersion: campaign.version,
  });
};

export const trackInteraction = (campaign: Campaign, elementId: string, buttonName?: string) => {
  return publish(POPOVER_INTERACTION, {
    buttonName,
    elementInteraction: elementId,
    campaignId: campaign.campaign,
    campaignVersion: campaign.version,
  });
};

export const trackDismissed = (campaign: Partial<Campaign>, buttonLabel: string) => {
  return publish(POPOVER_DISMISSED, {
    buttonName: buttonLabel,
    campaignId: campaign.campaign,
    campaignVersion: campaign.version,
  });
};

export const trackError = (campaign: Partial<Campaign>, error: Error) => {
  return publish(POPOVER_ERROR, {
    campaignId: campaign.campaign,
    campaignVersion: campaign.version,
    errorName: error.name,
    errorMessage: error.message,
  });
};
